/**
 * Common Header for public pages (Legal pages, etc.)
 * Matches the landing page header style
 */
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const PublicHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white shadow-sm'}`}>
      <div className="container mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
        <Link to="/">
          <Logo className="h-8 sm:h-10 w-auto" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          <Link to="/#funcionalidades" className="font-medium text-gray-700 hover:text-[#1a56db] transition">Funcionalidades</Link>
          <Link to="/#como-funciona" className="font-medium text-gray-700 hover:text-[#1a56db] transition">Como Funciona</Link>
          <Link to="/#precos" className="font-medium text-gray-700 hover:text-[#1a56db] transition">Preços</Link>
        </div>
        <div className="flex items-center gap-2 sm:gap-4">
          <Link 
            to="/login" 
            className="px-4 py-2 sm:px-5 sm:py-2.5 font-medium rounded-full transition border-2 border-gray-200 text-gray-700 hover:border-[#1a56db] hover:text-[#1a56db]"
          >
            Entrar
          </Link>
          <Link 
            to="/subscribe?plan=free" 
            className="hidden sm:flex px-6 py-2.5 bg-[#1a56db] hover:bg-[#1648c0] text-white rounded-full font-medium transition shadow-lg shadow-blue-500/25"
          >
            Começar Grátis
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default PublicHeader;
